import React from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import { H6 } from '../../../AbstractElements';
import LicenseRadial from './LicenseRadial';

const LicenseSummaryCard = ({ asset, status }) => {
    const usage = status ? status.usagePct : 0;
    const balance = status ? status.balance : 0;
    const warn = usage > 80 && !(balance < 0);
    const overdrawn = balance < 0;

    const color = overdrawn || warn ? '#f73164' : '#00b1c2';

    const wrapperClass = [
        'license-asset-card',
        warn ? 'license-asset-card--warn' : '',
        overdrawn ? 'license-asset-card--overdrawn' : ''
    ].filter(Boolean).join(' ');

    return (
        <Col xl='4' lg='6' md='6' sm='12' className={wrapperClass}>
            <Card>
                <CardBody>
                    <div className='d-flex justify-content-between align-items-start'>
                        <div>
                            <H6 attrH6={{ className: 'mb-1' }}>{asset.property_name}</H6>
                            <div className='f-12 f-light'>
                                {asset.property_mall_code}
                                {overdrawn && <span className='license-badge license-badge--overdraft ms-2'>OVERDRAWN</span>}
                            </div>
                        </div>
                    </div>

                    <div className='d-flex align-items-center justify-content-between mt-3'>
                        <div className='license-inline-stats'>
                            <div className='license-stat'>
                                <div className='v'>{status ? status.balance : '—'}</div>
                                <div className='l'>Balance</div>
                            </div>
                            <div className='license-stat'>
                                <div className='v'>{status ? status.available : '—'}</div>
                                <div className='l'>Available</div>
                            </div>
                            <div className='license-stat'>
                                <div className='v'>{status ? status.consumed : '—'}</div>
                                <div className='l'>Consumed</div>
                            </div>
                            {status && status.overdrafts > 0 && (
                                <div className='license-stat'>
                                    <div className='v'>{status.overdrafts}</div>
                                    <div className='l'>Overdraft</div>
                                </div>
                            )}
                        </div>
                        <div style={{ width: 120 }}>
                            <LicenseRadial percent={usage} color={color} height={140} />
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

export default LicenseSummaryCard;
